import { ThunkResult } from '../../store'
import customLabelApi, { CustomLabelDeletePrintsRequest } from '../../apis/customLabel.api'
import { replaceResult, replaceResultData } from './CustomLabelPrintsPaginate.slice'
import customLabelPrintService from '../../services/customLabelPrint.service'

export function paginate (): ThunkResult<void> {
  return (dispatch, getState) => {
    const { id, page, limit, search } = getState().customLabelPrintsPaginate
    if (!id) return
    const params = { page, limit, search }
    customLabelApi.paginatePrints(id, params, paginate => {
      if (!paginate) return
      dispatch(replaceResult(paginate))
    })
  }
}

export function deletePrints (ids: number[], callback: () => void): ThunkResult<void> {
  return (dispatch, getState) => {
    const payload: CustomLabelDeletePrintsRequest = {
      prints: ids
    }
    const { id } = getState().customLabelPrintsPaginate
    if (!id) return
    customLabelApi.deletePrints(id, payload, response => {
      if (!response) return
      const { result } = getState().customLabelPrintsPaginate
      const data = customLabelPrintService.deleteMany(result.data, ids)
      dispatch(replaceResultData(data))
      callback()
    })
  }
}
